import { RADIO_DEFAULT_MODE, RADIO_DEFAULT_SIZE } from '../Radio/Radio.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default 'disabled' values. */
export const RADIO_GROUP_DEFAULT_DIRECTION = 'column';
export const RADIO_GROUP_DEFAULT_DISABLED = false;
export const RADIO_GROUP_DEFAULT_MODE = RADIO_DEFAULT_MODE;
export const RADIO_GROUP_DEFAULT_SIZE = RADIO_DEFAULT_SIZE;
//# sourceMappingURL=RadioGroup.constants.js.map